import { Avatar, AvatarGroup, Button, ButtonGroup, FormSection } from '@ksyos/design-system';
import { sortBy } from 'lodash';
import type { IOrganizationAddCarePathState, IRole } from '../../../../interfaces/organizationAddCarePathState';
import type { IProfile } from '../steps/AssignRoles';
import { getNameInitials } from '../../../../../../common/utils/getNameInitials';
import { translateKey } from '../../../../../translate';

interface IRoleCardItemProps {
    addCarePathState: IOrganizationAddCarePathState;
    isSameAsDefaultSettings: boolean;
    onChangePractitioner: (profileId: string) => void;
    onClickSettings: (id: string) => void;
    profile: IProfile;
}

export function RoleCardItem(props: IRoleCardItemProps) {
    const currentRole = props.addCarePathState.roles?.find((role) => role.profileId === props.profile.id) as IRole;

    return (
        <FormSection
            key={props.profile.id}
            title={props.profile.name}
        >
            {currentRole && getAvatars()}
            <ButtonGroup
                size="small"
                style={{ marginBottom: 8 }}
                variant="link"
            >
                <Button
                    iconLeft="add"
                    onClick={() => props.onChangePractitioner(props.profile.id)}
                >
                    {translateKey(currentRole ? 'practitioner.addOrRemoveMultiple' : 'practitioner.addMultiple')}
                </Button>
                <Button
                    iconLeft="settings"
                    onClick={() => props.onClickSettings(props.profile.id)}
                >
                    {translateKey(props.isSameAsDefaultSettings ? 'common.advanced' : 'common.advancedUpdated')}
                </Button>
            </ButtonGroup>
        </FormSection>
    );

    function getAvatars() {
        const employmentsSortedByProfilePictureUrl = sortBy(currentRole.employments, [
            'practitioner.profilePictureUrl',
        ]);

        return (
            <AvatarGroup
                limit={2}
                size={48}
                style={{ marginTop: 8, marginBottom: 16 }}
            >
                {employmentsSortedByProfilePictureUrl.map((employment) => (
                    <Avatar
                        imageUrl={employment.practitioner?.profilePictureUrl}
                        initials={
                            employment.practitioner!.nameGiven && !employment.practitioner?.profilePictureUrl
                                ? getNameInitials(employment.practitioner!.nameGiven, '')
                                : ''
                        }
                        key={employment.id}
                    />
                ))}
            </AvatarGroup>
        );
    }
}
